import { render, staticRenderFns } from "./AccreditationDetail.vue?vue&type=template&id=766c4d63&"
import script from "./AccreditationDetail.vue?vue&type=script&lang=js&"
export * from "./AccreditationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports